import React from 'react';

import Intro from '../intro/intro';
import MainHistory from '../main_history/main_history';

const Company = () => {
    return (
        <div>
            <Intro />
            <MainHistory />
        </div>
    )
}

export default Company;